module.exports = __webpack_public_path__ + "img/absolut-form-bg-mobile.538d13dc.jpg";